import styled from 'styled-components';
const SidebarWrapper = styled.div`
.page-header  {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--page-header-width);
    color: var(--page-header-txtColor);
    background: var(--page-header-bgColor);
    font-family:"open sans", sans-serif;
    z-index:999;
    min-height:90px;
    nav{
    min-height:90px;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    // min-height: 100%;
    margin:0;
    padding:20px;
    }
    .scrollable-content{
        padding-bottom:90px;
    }
    .section-title{
        font-size: 14px;
        color: #ffffff;
        font-weight: 600;
        text-transform: uppercase;
        padding: 0 0 10px;
    }
    h3{
        font:"open sans", sans-serif;
        color:#4eb0de;
        margin:0;
        padding:7px 0 0;
        font-size:14px;
        text-transform:uppercase;
        font-weight:300;
    }
    .logo {
        display: block;
        max-width: 120px;
        margin: 0;
      }
      .toggle-mob-menu {
        display: none;
        margin-left: 5px;
        padding: 4px;
        background: var(--page-content-blockColor);
        border-radius: var(--border-radius);
      }

      .toggle-mob-menu svg {
        fill: var(--black);
        -webkit-transition: -webkit-transform 0.2s;
        transition: -webkit-transform 0.2s;
        transition: transform 0.2s;
        transition: transform 0.2s, -webkit-transform 0.2s;
      }

      .admin-menu {
            display: -webkit-box;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
                    flex-direction: column;
            -webkit-box-flex: 1;
                    flex-grow: 1;
            margin-top: 35px;
            li{
                &:nth-last-child(2) {
                    margin-bottom: 35px;
                }
                &:last-child {
                    margin-bottom: 35px;
                }
                > * {
                    width: 100%;
                    padding: 12px 15px;
                }
            }
            .menu-heading{
                h3 {
                    text-transform: uppercase;
                    letter-spacing: 0.15em;
                    font-size: 12px;
                    margin-top: 12px;
                    color: var(--page-header-headingColor);
                }
              }
              svg {
                width: 20px;
                height: 20px;
                fill: var(--page-header-txtColor);
                margin-right: 10px;
                -webkit-transition: fill 0.2s;
                transition: fill 0.2s;
              }
              >a{
                display: -webkit-box;
                display: flex;
                -webkit-box-align: center;
                        align-items: center;
                font-size: 0.9rem;
                -webkit-transition: background 0.2s, color 0.2s;
                transition: background 0.2s, color 0.2s;
                &:hover{
                    background: var(--page-header-bgColor-hover);
                    color: var(--blue);
                    outline: none;
                }
              }
              >button{
                display: -webkit-box;
                display: flex;
                -webkit-box-align: center;
                        align-items: center;
                font-size: 0.9rem;
                -webkit-transition: background 0.2s, color 0.2s;
                transition: background 0.2s, color 0.2s;
                &:hover{
                    background: var(--page-header-bgColor-hover);
                    color: var(--blue);
                    outline: none; 
                }
              }
        }

        .patient-queue{
            padding:20px;
            >h1{
            font-size:14px;
            color:#ffffff;
            font-weight:600;
            text-transform:uppercase;
            padding:0 0 10px;
            }
            >h2{
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              font-style: italic;
              line-height: 1.36;
              letter-spacing: normal;
              text-align: left;
              color: #b2b9d6;
            }
            .patient-lists{
                >ul{
                    >li{
                        margin-bottom:20px;
                      .patient-cards{
                          background:#fff;
                          padding:10px 20px;
                          border-radius: 10px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          .patient-detail{
                              >h1{
                                font-size:14px;
                                color:#344177;
                                font-weight:normal;
                                text-transform:capitalize;
                                font-weight:700;
                              }
                              >h2{
                                font-size:11px;
                                color:#344177;
                                font-weight:normal;
                              }
                          }
                          .actions{
                            display: flex;
                            flex-direction: column;
                            .kurebtn{
                                margin:2px 0;
                            }
                              .start-call{
                                background:#4eb0de;
                                border:1px solid #4eb0de;
                              }
                              .visit-details{
                                background:#fffff;
                                color:#4eb0de;
                                border:1px solid #4eb0de;
                              }
                              .end-call{
                                border:1px solid #fa3260;
                                background:#fa3260;
                            }
                            .anand{
                              border:1px solid #000;
                            }
                            .view-details{
                              margin-left: 25px;
                              .ant-popover-inner{
                              border-radius:10px;
                              padding:15px;
                              }
                            }
                          }
                      } 
                      &.active{
                            .patient-cards{
                              background:#4eb0de;
                              .patient-detail{
                                    >h1{
                                    color:#ffffff;
                                    font-weight:600;
                                    }
                                    >h2{
                                    color:#ffffff;
                                    }
                                }


                                .actions{
                                   .visit-details{
                                      background:none;
                                      border:1px solid #fff;
                                      color:#ffffff;
                                    }
                                }   
                                
                            }
                      } 
                    }
                }
            }
            }

        }

        .provider-schedule{
            padding:20px;
            .provider-schedule-lists{
                >ul{
                    >li{
                      margin-bottom:10px;
                        .schedule-card{
                            padding:20px;
                            border-radius: 10px;
                            border: solid 1px #b2b9d6;
                            .p-0{
                              padding:0 !important;
                            }
                            h1{
                                font-size:13px;
                                color:#ffffff;
                                font-weight:normal;
                                text-transform:uppercase;
                                font-weight:700;
                            }
                            h2{
                                font-size:14px;
                                color:#ffffff;
                                font-weight:normal;
                                text-transform:capitalize;
                                font-weight:300;
                                padding:0 0 15px;
                            }
                            h3{
                              font-size:17px;
                              color:#ffffff;
                              font-weight:normal;
                              text-transform:capitalize;
                              font-weight:600;
                              padding:0;
                          }
                        }
                    }
                }
            }
        }
  }


`;


export default (SidebarWrapper);